window.addEventListener("load", function() {
    // Esta function comprueba consentimiento que el usuario selecciona y activa los eventos que envía al GTM
    function update_evnet_consent_state(cc) {
        var cat_analytics = cc.allowedCategory("analytics_storage")
            ? "granted"
            : "denied";
        var cat_storage = cc.allowedCategory("ad_storage")
            ? "granted"
            : "denied";
        var cat_personalization = cc.allowedCategory("personalization")
            ? "granted"
            : "denied";
        gtag("consent", "update", {
            ad_storage: cat_storage,
            ad_user_data: cat_storage,
            ad_personalization: cat_storage,
            analytics_storage: cat_analytics,
            personalization_storage: cat_personalization
        });
    }

    var cc = initCookieConsent();

    // run plugin with your configuration
    cc.run({
        gui_options: {
            consent_modal: {
                layout: "cloud", // box/cloud/bar
                position: "bottom center", // bottom/middle/top + left/right/center
                transition: "slide", // zoom/slide
                swap_buttons: false // enable to invert buttons
            },
            settings_modal: {
                layout: "bar", // box/bar
                // position: 'left',           // left/right
                transition: "slide" // zoom/slide
            }
        },
        current_lang: "es-es",
        autoclear_cookies: true, // default: false
        page_scripts: true, // default: false

        // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
        // delay: 0,                               // default: 0
        auto_language: "document", // default: null; could also be 'browser' or 'document'
        // autorun: true,                          // default: true
        // force_consent: false,                   // default: false
        // hide_from_bots: false,                  // default: false
        // remove_cookie_tables: false             // default: false
        cookie_name: "cc_cookie", // default: 'cc_cookie'
        cookie_expiration: 182, // default: 182 (days)
        // cookie_necessary_only_expiration: 182   // default: disabled
        // cookie_domain: location.hostname,       // default: current domain
        cookie_path: "/", // default: root
        // cookie_same_site: 'Lax',                // default: 'Lax'
        // use_rfc_cookie: false,                  // default: false
        // revision: 0,                            // default: 0

        onFirstAction: function(user_preferences, cookie) {
            // callback triggered only once
            window.dataLayer.push({ event: "consent-update" });
        },
        onAccept: function(cookie) {
            update_evnet_consent_state(cc); //Llamamos a la funcion para actualizar el estado
            window.dataLayer.push({ event: "consent-update" });
            window.dataLayer.push({ event: "dw_fire" });
        },
        onChange: function(cookie, changed_preferences) {
            update_evnet_consent_state(cc); //Llamamos a la funcion para actualizar el estado
            window.dataLayer.push({ event: "consent-update" });
        },

        languages: {
            es: {
                consent_modal: {
                    title: "¡Utilizamos cookies!",
                    description:
                        'Hola, este sitio web utiliza cookies esenciales para garantizar su correcto funcionamiento, cookies de seguimiento para entender cómo interactúas con él y de marketing para la personalización de anuncios. Estas últimas solo se instalarán previo consentimiento. <button type="button" data-cc="c-settings" class="cc-link">Déjame elegir</button>.',

                    secondary_btn: {
                        text: "Aceptar las necesarias",
                        role: "accept_necessary" // 'settings' or 'accept_necessary'
                    },
                    primary_btn: {
                        text: "Aceptar todas",
                        role: "accept_all" // 'accept_selected' or 'accept_all'
                    }
                },
                settings_modal: {
                    title: "Preferencias de cookies",
                    save_settings_btn: "Guardar ajustes",
                    accept_all_btn: "Aceptar todas",
                    reject_all_btn: "Rechazar todas",
                    close_btn_label: "Cerrar",
                    cookie_table_headers: [
                        { col1: "Nombre" },
                        { col2: "Dominio" },
                        { col3: "Caducidad" },
                        { col4: "Descripción" }
                    ],
                    blocks: [
                        {
                            title: "Uso de cookies 📢",
                            description:
                                'Utilizamos cookies para garantizar las funcionalidades básicas del sitio web y mejorar su experiencia en línea. Usted podrá seleccionar/deseleccionar cada categoría siempre que lo desee. Para más información sobre las cookies y otros datos sensibles, lea la <a href="/politica-de-privacidad/" class="cc-link">política de privacidad</a>.'
                        },
                        {
                            title: "Cookies estrictamente necesarias",
                            description:
                                "Estas cookies son esenciales para el correcto funcionamiento del sitio web. Sin estas cookies, el sitio no funcionaría correctamente.",
                            toggle: {
                                value: "necessary",
                                enabled: true,
                                readonly: true // cookie categories with readonly=true are all treated as "necessary cookies"
                            },
                            cookie_table: [
                                {
                                    col1: "language",
                                    col2: "https://cbreresidencial.es/",
                                    col3:
                                        "Necesaria para identificar qué idioma utiliza el usuario.",
                                    col4: "Persistente"
                                },
                                {
                                    col1: "cc_cookie",
                                    col2: "https://cbreresidencial.es/",
                                    col3:
                                        "Necesaria para identificar qué cookies ha permitido el usuario.",
                                    col4: "6 meses"
                                },
                                {
                                    col1: "_hjSession_*",
                                    col2: "https://www.hotjar.com/es/",
                                    col3:
                                        "Para proporcionar funciones en todas las páginas.",
                                    col4: "1 día"
                                }
                            ]
                        },
                        {
                            title: "Cookies de rendimiento y análisis",
                            description:
                                "Estas cookies permiten que el sitio web recuerde las elecciones que ha hecho en el pasado",
                            toggle: {
                                value: "analytics_storage", // your cookie category
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [
                                // list of all expected cookies
                                {
                                    col1: "_ga",
                                    col2: "google-analytics.com/analytics.js",
                                    col3:
                                        "Registra una identificación única que se utiliza para generar datos estadísticos acerca de cómo utiliza el visitante el sitio web.",
                                    col4: "2 años"
                                },
                                {
                                    col1: "_gat",
                                    col2: "google-analytics.com/analytics.js",
                                    col3:
                                        "Utilizado por Google Analytics para controlar la tasa de peticiones.",
                                    col4: "1 día"
                                },
                                {
                                    col1: "_gid",
                                    col2: "google-analytics.com/analytics.js",
                                    col3:
                                        "Registra una identificación única que se utiliza para generar datos estadísticos acerca de cómo utiliza el visistante el sitio web.",
                                    col4: "1 día"
                                },

                                {
                                    col1: "_hjSessionUser_*",
                                    col2: "https://www.hotjar.com/es/",
                                    col3:
                                        "para almacenar una identificación de usuario única.",
                                    col4: "1 año"
                                },
                                {
                                    col1: "_hjIncludedInSessionSample_*",
                                    col2: "https://www.hotjar.com/es/",
                                    col3: "Función desconocida",
                                    col4: "30 minutos"
                                },
                                {
                                    col1: "_hjFirstSeen",
                                    col2: "https://www.hotjar.com/es/",
                                    col3:
                                        "Para almacenar la primera visita al sitio.",
                                    col4: "30 minutos"
                                },
                                {
                                    col1: "_hjAbsoluteSessionInProgress",
                                    col2: "https://www.hotjar.com/es/",
                                    col3: "Para almacenar visitas únicas.",
                                    col4: "30 minutos"
                                }
                            ]
                        },
                        {
                            title: "Cookies de publicidad y segmentación",
                            description:
                                "Estas cookies recogen información sobre cómo utiliza el sitio web, qué páginas ha visitado y en qué enlaces ha hecho clic. Todos los datos son anónimos y no pueden utilizarse para identificarle.",
                            toggle: {
                                value: "ad_storage",
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [
                                // list of all expected cookies
                                {
                                    col1: "ads/ga-audiences",
                                    col2:
                                        "www.google-analytics.com/analytics.js",
                                    col3:
                                        "Utilizada por Google AdWords para reconectar con visitantes que tienen posibilidades de convertirse en clientes.",
                                    col4: "Sesión"
                                },
                                {
                                    col1: "_gcl_au",
                                    col2:
                                        "www.google-analytics.com/analytics.js",
                                    col3:
                                        "Para almacenar y realizar un seguimiento de las conversiones.",
                                    col4: "Persistente"
                                }
                            ]
                        },
                        {
                            title: "Saber más",
                            description:
                                'Para más información consulte nuestra página de <a class="cc-link" href="/politica-de-cookies/"> política de cookies</a>'
                        }
                    ]
                }
            },
            en: {
                consent_modal: {
                    title: "We use cookies!",
                    description:
                        'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
                    primary_btn: {
                        text: "Accept all",
                        role: "accept_all" // 'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: "Accept necessary",
                        role: "accept_necessary" // 'settings' or 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: "Cookie preferences",
                    save_settings_btn: "Save settings",
                    accept_all_btn: "Accept all",
                    reject_all_btn: "Reject all",
                    close_btn_label: "Close",
                    cookie_table_headers: [
                        { col1: "Name" },
                        { col2: "Domain" },
                        { col3: "Expiration" },
                        { col4: "Description" }
                    ],
                    blocks: [
                        {
                            title: "Cookie usage 📢",
                            description:
                                'We are using cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="/en/privacy-policy/" class="cc-link">privacy policy</a>.'
                        },
                        {
                            title: "Strictly necessary cookies",
                            description:
                                "These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly",
                            toggle: {
                                value: "necessary",
                                enabled: true,
                                readonly: true // cookie categories with readonly=true are all treated as "necessary cookies"
                            },
                            cookie_table: [
                                {
                                    col1: "language",
                                    col2: "https://urosassociats.com/",
                                    col3:
                                        "Necessary to identify which language the user is using.",
                                    col4: "Persistent"
                                },
                                {
                                    col1: "cc_cookie",
                                    col2: "https://urosassociats.com//",
                                    col3:
                                        "Necessary to identify which cookies the user has allowed.",
                                    col4: "6 months"
                                },
                                {
                                    col1: "_hjSession_*",
                                    col2: "https://www.hotjar.com/es/",
                                    col3:
                                        "To provide functionality on all pages.",
                                    col4: "1 day"
                                }
                            ]
                        },
                        {
                            title: "Performance and Analytics cookies",
                            description:
                                "These cookies allow the website to remember the choices you have made in the past",
                            toggle: {
                                value: "analytics_storage", // your cookie category
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [
                                // list of all expected cookies
                                {
                                    col1: "_ga",
                                    col2: "google-analytics.com/analytics.js",
                                    col3:
                                        'The main cookie used by Google Analytics, enables a service to distinguish one visitor from another and lasts for 2 years. Any site that implements Google Analytics, including Google services, uses the "_ga" cookie. Each "_ga" cookie is unique to the specific property, so it cannot be used to track a given user or browser across unrelated websites.',
                                    col4: "2 years"
                                },
                                {
                                    col1: "_gat",
                                    col2: "google-analytics.com/analytics.js",
                                    col3:
                                        "Used by Google Analytics to monitor request rates.",
                                    col4: "1 day"
                                },
                                {
                                    col1: "_gid",
                                    col2: "google-analytics.com/analytics.js",
                                    col3:
                                        "It records a unique ID that is used to generate statistical data about how the visitor uses the website.",
                                    col4: "1 day"
                                },
                                {
                                    col1: "_hjSessionUser_*",
                                    col2: "https://www.hotjar.com/es/",
                                    col3: "To store a unique user ID.",
                                    col4: "1 year"
                                },
                                {
                                    col1: "_hjIncludedInSessionSample_*",
                                    col2: "https://www.hotjar.com/es/",
                                    col3: "Unknown function",
                                    col4: "30 min"
                                },
                                {
                                    col1: "_hjFirstSeen",
                                    col2: "https://www.hotjar.com/es/",
                                    col3:
                                        "To store the first visit to the site.",
                                    col4: "30 min"
                                },
                                {
                                    col1: "_hjAbsoluteSessionInProgress",
                                    col2: "https://www.hotjar.com/es/",
                                    col3: "To store unique visits.",
                                    col4: "30 min"
                                }
                            ]
                        },
                        {
                            title: "Advertising and targeting cookies",
                            description:
                                "These cookies collect information about how you use the website, which pages you have visited and which links you have clicked on. All data is anonymous and cannot be used to identify you.",
                            toggle: {
                                value: "ad_storage",
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [
                                // list of all expected cookies
                                {
                                    col1: "ads/ga-audiences",
                                    col2:
                                        "www.google-analytics.com/analytics.js",
                                    col3:
                                        "Used by Google AdWords to reconnect with visitors who are likely to become customers.",
                                    col4: "Session"
                                },
                                {
                                    col1: "_gcl_au",
                                    col2:
                                        "www.google-analytics.com/analytics.js",
                                    col3:
                                        "Used by Google AdSense to experiment with advertising efficiency across websites using their services.",
                                    col4: "Persistent"
                                }
                            ]
                        },
                        {
                            title: "More information",
                            description:
                                'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="/contacto/">contact us</a>.'
                        }
                    ]
                }
            }
        }
    });
});
